export default __webpack_public_path__ + "static/media/veelson.8b70c5bb.png";